import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';

import { Store } from '@ngrx/store';
import { I18NextPipe } from 'angular-i18next';
import { I18_KEY } from 'mbs-ui-shared@services/smart-search-template.service';
import moment from 'moment';
import { map, tap } from 'rxjs/operators';
import { GAActions, GASelectors } from '.';
import * as ScheduleGroupTaskActions from '../rmmGroupTasks/actions';
import { GroupTaskReg } from '../rmmGroupTasks/model';
import * as ScheduleGroupTaskSelectors from '../rmmGroupTasks/selectors';
import { WizardGroupAction } from './model';

@Injectable()
export class RmmGroupTaskWizardEffects {
  private actions$ = inject(Actions);
  private store = inject(Store);
  private i18n = inject(I18NextPipe);

  saveGroupActionTaskChanges$ = createEffect(() => {
    return this.actions$.pipe(ofType(GAActions.saveGActionChanges)).pipe(
      concatLatestFrom(() => [
        this.store.select(GASelectors.selectGroupActionState),
        this.store.select(ScheduleGroupTaskSelectors.selectGroupTaskToEditGuid)
      ]),
      tap(([action, wizardGroupTask, groupTaskToEdit]) =>
        this.store.dispatch(
          ScheduleGroupTaskActions.saveChangesToGroupTask({
            groupTaskGuid: groupTaskToEdit,
            task: this.getGroupTaskFromData({ ...wizardGroupTask })
          })
        )
      ),
      map(() => GAActions.successGroupAction())
    );
  });

  saveGroupActionTask$ = createEffect(() => {
    return this.actions$.pipe(ofType(GAActions.saveNewGAction)).pipe(
      concatLatestFrom(() => this.store.select(GASelectors.selectGroupActionState)),
      tap(([, wizardGroupTask]) =>
        this.store.dispatch(ScheduleGroupTaskActions.registerGroupTask({ task: this.getGroupTaskFromData({ ...wizardGroupTask }) }))
      ),
      map(() => GAActions.successGroupAction())
    );
  });

  private getGroupTaskFromData(data: WizardGroupAction): GroupTaskReg {
    return {
      ...data.parameters,
      ...data.schedule,
      allComputers: data.applyTo.allCompanies,
      companies: data.applyTo.companies,
      computers: data.applyTo.computers,
      computerTags: data.applyTo.computerTags,
      name: data.name,
      osType: data.osType
    } as GroupTaskReg;
  }

  getTimeOutError(timeout = 60000) {
    const t = moment.duration(timeout).asSeconds();

    return this.i18n.transform(`${I18_KEY}errors.timeout`, { timeout: t });
  }
}
